export default __webpack_public_path__ + "static/media/purchaseGrn.87cd66c6.svg";